// import React, { Component } from "react";

// import DelayLink from "../../helpers/delayLink";
// import { brandRoute } from "../../../helpers/restaurantSlugDetector";
// import Ink from "react-ink";
// import Meta from "../../helpers/meta";
// import { NavLink } from "react-router-dom";
// import ProgressiveImage from "react-progressive-image";
// import { connect } from "react-redux";
// import { getSettings } from "../../../services/settings/actions";
// import { getSingleLanguageData } from "../../../services/languages/actions";

// class FirstScreen extends Component {
// 	state = {
// 		splashVersion: 1,
// 		heroImage: null,
// 	};
// 	componentDidMount() {
// 		this.removeSplashScreen();
// 		if (localStorage.getItem("storeColor")) {
// 			setTimeout(() => {
// 				this.removeSplashScreen();
// 			}, 1000);
// 		}
// 		let splashVersion = Math.random() * Math.floor(9999999);
// 		localStorage.setItem("splashVersion", splashVersion);
// 		this.setState({ splashVersion: splashVersion });
		
// 		// Check for hero image in localStorage
// 		this.updateHeroImage();
		
// 		// Listen for storage changes (when API sets brandHeroImage)
// 		window.addEventListener('storage', this.handleStorageChange);
// 		// Also check periodically in case localStorage was set in same window
// 		this.heroImageCheckInterval = setInterval(() => {
// 			this.updateHeroImage();
// 		}, 500);
// 	}
	
// 	componentWillUnmount() {
// 		window.removeEventListener('storage', this.handleStorageChange);
// 		if (this.heroImageCheckInterval) {
// 			clearInterval(this.heroImageCheckInterval);
// 		}
// 	}
	
// 	handleStorageChange = (e) => {
// 		if (e.key === 'brandHeroImage' || e.key === 'firstScreenHeroImage') {
// 			this.updateHeroImage();
// 		}
// 	}
	
// 	updateHeroImage = () => {
// 		const brandHeroImage = localStorage.getItem("brandHeroImage");
// 		const firstScreenHeroImage = localStorage.getItem("firstScreenHeroImage");
// 		const heroImage = brandHeroImage || firstScreenHeroImage;
		
// 		if (heroImage !== this.state.heroImage) {
// 			this.setState({ heroImage });
// 		}
// 	}

// 	removeSplashScreen = () => {
// 		if (document.getElementById("firstScreenSplash")) {
// 			document.getElementById("firstScreenSplash").remove();
// 		}
// 		if (document.getElementById("firstScreenMain")) {
// 			 document.getElementById("firstScreenMain").classList.remove("hidden");
// 		}
// 	};

// 	handleOnChange = (event) => {
// 		// console.log(event.target.value);
// 		this.props.getSingleLanguageData(event.target.value);
// 		localStorage.setItem("userPreferedLanguage", event.target.value);
// 	};

// 	componentWillReceiveProps(nextProps) {
// 		const { settings } = this.props;
// 		if (settings !== nextProps.settings) {
// 			//settings received, then hide the splash screen after 2s
// 			setTimeout(() => {
// 				this.removeSplashScreen();
// 			}, 1000);
// 		}

// 		if (this.props.languages !== nextProps.languages) {
// 			if (localStorage.getItem("userPreferedLanguage")) {
// 				this.props.getSingleLanguageData(localStorage.getItem("userPreferedLanguage"));
// 				// console.log("Called 1");
// 			} else {
// 				if (nextProps.languages.length) {
// 					const id = nextProps.languages.filter((lang) => lang.is_default === 1)[0].id;
// 					this.props.getSingleLanguageData(id);
// 				}
// 			}
// 		}
// 	}

// 	render() {
// 		const { user } = this.props;

// 		// Always show first-screen; don't auto-redirect when location is already set

// 		return (
// 			<React.Fragment>
// 				<Meta
// 					seotitle={localStorage.getItem("seoMetaTitle")}
// 					seodescription={localStorage.getItem("seoMetaDescription")}
// 					ogtype="website"
// 					ogtitle={localStorage.getItem("seoOgTitle")}
// 					ogdescription={localStorage.getItem("seoOgDescription")}
// 					ogurl={window.location.href}
// 					twittertitle={localStorage.getItem("seoTwitterTitle")}
// 					twitterdescription={localStorage.getItem("seoTwitterDescription")}
// 				/>
// 				<div>
// 					<div className="col-12 p-0" id="firstScreenSplash">
// 						<div className="block m-0">
// 							<div className="block-content p-0">
// 								<img
// 									src={`/assets/img/splash/splash.jpg?v=${this.state.splashVersion}`}
// 									className="img-fluid"
// 									alt={localStorage.getItem("storeName")}
// 									style={{
// 										width: "100%",
// 									}}
// 								/>
// 							</div>
// 						</div>
// 					</div>
// 					<div
// 						className="col-12 p-0 hidden"
// 						id="firstScreenMain"
// 						style={{ height: `${window.innerHeight}px` }}
// 					>
// 						<div className="block m-0 ">
// 							<div className="block-content p-0">
// 								{this.state.heroImage && (
// 									<ProgressiveImage
// 										delay={100}
// 										src={this.state.heroImage}
// 										placeholder={(() => {
// 											const placeholder = localStorage.getItem("firstScreenHeroImageSm");
// 											// Only use placeholder if it exists and is a full URL or starts with /assets
// 											if (placeholder && (placeholder.startsWith('http') || placeholder.startsWith('/assets'))) {
// 												return placeholder;
// 											}
// 											return null;
// 										})()}
// 									>
// 										{(src, loading) => (
// 											<img
// 												src={src}
// 												alt={localStorage.getItem("storeName")}
// 												className="img-fluid"
// 												style={{
// 													filter: loading ? "blur(1.2px) brightness(0.9)" : "none",
// 													width: `${window.innerWidth}px`,
// 												}}
// 												onError={(e) => {
// 													// Only log error if it's the main image, not placeholder
// 													if (src === this.state.heroImage) {
// 														console.error('❌ Failed to load hero image:', src);
// 														e.target.style.display = 'none';
// 													}
// 												}}
// 												onLoad={() => {
// 													// Only log success if it's the main image
// 													if (src === this.state.heroImage) {
// 														 console.log('✅ Hero image loaded successfully:', src);
// 													}
// 												}}
// 											/>
// 										)}
// 									</ProgressiveImage>
// 								)}
// 							</div>
// 						</div>
// 						<div className="block m-0">
// 							<div className="block-content pt-10">
// 								<h1 className="welcome-heading mt-10">{localStorage.getItem("firstScreenHeading")}</h1>
// 								<h2 className="welcome-subheading text-center mt-10 mb-10">
// 									{localStorage.getItem("firstScreenSubHeading")}
// 								</h2>
// 							<DelayLink
// 								to={brandRoute("/search-location")}
// 								delay={200}
// 								className="btn btn-lg btn-setup-location"
// 								style={{
// 									backgroundColor: localStorage.getItem("storeColor"),
// 									position: "relative",
// 								}}
// 							>
// 								{localStorage.getItem("firstScreenSetupLocation")}
// 								<Ink duration="500" hasTouch="true" />
// 							</DelayLink>
// 								{user.success ? (
// 									<p className="login-block font-w500 mb-0 firstscreen-loggedin-message-block">
// 										{localStorage.getItem("firstScreenWelcomeMessage")} {user.data.name}
// 									</p>
// 								) : (
// 								<p className="login-block mb-0 firstscreen-login-link-block">
// 									{localStorage.getItem("firstScreenLoginText")}{" "}
// 									<NavLink
// 										to={brandRoute("/login")}
// 										style={{ color: localStorage.getItem("storeColor") }}
// 										className="firstscreen-login-link"
// 									>
// 										{localStorage.getItem("firstScreenLoginBtn")}
// 									</NavLink>
// 								</p>
// 								)}

// 								{this.props.languages && this.props.languages.length > 1 && (
// 									<div className="mt-4 d-flex align-items-center justify-content-center mb-100">
// 										<div className="mr-2">{localStorage.getItem("changeLanguageText")}</div>
// 										<select
// 											onChange={this.handleOnChange}
// 											defaultValue={
// 												localStorage.getItem("userPreferedLanguage")
// 													? localStorage.getItem("userPreferedLanguage")
// 													: this.props.languages.filter((lang) => lang.is_default === 1)[0].id
// 											}
// 											className="form-control language-select"
// 										>
// 											{this.props.languages.map((language) => (
// 												<option value={language.id} key={language.id}>
// 													{language.language_name}
// 												</option>
// 											))}
// 										</select>
// 									</div>
// 								)}
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</React.Fragment>
// 		);
// 	}
// }

// const mapStateToProps = (state) => ({
// 	settings: state.settings.settings,
// 	user: state.user.user,
// 	languages: state.languages.languages,
// 	language: state.languages.language,
// });

// export default connect(
// 	mapStateToProps,
// 	{ getSettings, getSingleLanguageData }
// )(FirstScreen);

import React, { Component } from "react";
import DelayLink from "../../helpers/delayLink";
import { brandRoute } from "../../../helpers/restaurantSlugDetector";
import Ink from "react-ink";
import Meta from "../../helpers/meta";
import { NavLink } from "react-router-dom";
import ProgressiveImage from "react-progressive-image";
import { connect } from "react-redux";

import { getSingleStoreConfig } from "../../../services/singlestore/actions";
import { getSingleLanguageData } from "../../../services/languages/actions";
import { getAssetUrl } from "../../helpers/getAssetUrl";
import { detectRestaurantSlug } from "../../../helpers/restaurantSlugDetector";
class FirstScreen extends Component {

  state = {
    heroImage: null,
    heading: "Welcome",
    subHeading: "Order your favorite food",
    loading: true
  };

 componentDidMount() {
  const slug = detectRestaurantSlug();

  console.log("🟢 Slug from detectRestaurantSlug:", slug);

  if (slug) {
    this.props.getSingleStoreConfig(slug);
  } else {
    console.log("❌ No slug detected from URL");
    this.setState({ loading: false });
  }
}
 componentDidUpdate(prevProps) {
  if (this.props.brand !== prevProps.brand) {
    console.log("🔥 BRAND FROM REDUX:", this.props.brand);
  }

  if (
    this.props.brand &&
    this.props.brand !== prevProps.brand
  ) {
    this.initializeFromBrand();
  }
}
  initializeFromBrand = () => {
    const { brand } = this.props;

    let heroImage = null;

    if (brand && brand.hero_image) {
      heroImage = getAssetUrl(`/assets/${brand.hero_image}`);
    }

    this.setState({
      heroImage,
      heading:
        localStorage.getItem("firstScreenHeading") || "Welcome",
      subHeading:
        localStorage.getItem("firstScreenSubHeading") ||
        "Order your favorite food",
      loading: false
    });
  };

  handleOnChange = (event) => {
    this.props.getSingleLanguageData(event.target.value);
    localStorage.setItem("userPreferedLanguage", event.target.value);
  };

  render() {

    if (this.state.loading) {
      return (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          Loading...
        </div>
      );
    }

    const { user } = this.props;
    const { heroImage, heading, subHeading } = this.state;

    const storeColor =
      localStorage.getItem("storeColor") || "#f58634";

    const setupText =
      localStorage.getItem("firstScreenSetupLocation") || "Set Location";

    const loginText =
      localStorage.getItem("firstScreenLoginText") ||
      "Already have an account?";

    const loginBtn =
      localStorage.getItem("firstScreenLoginBtn") || "Login";

    const welcomeMessage =
      localStorage.getItem("firstScreenWelcomeMessage") || "Welcome";

    return (
      <>
        <Meta
          seotitle={localStorage.getItem("seoMetaTitle") || "Home"}
          seodescription={localStorage.getItem("seoMetaDescription") || ""}
          ogtype="website"
          ogtitle={localStorage.getItem("seoOgTitle") || ""}
          ogdescription={localStorage.getItem("seoOgDescription") || ""}
          ogurl={window.location.href}
          twittertitle={localStorage.getItem("seoTwitterTitle") || ""}
          twitterdescription={localStorage.getItem("seoTwitterDescription") || ""}
        />

        <div style={{ minHeight: "100vh" }}>

          {/* HERO IMAGE */}
          {heroImage && (
            <ProgressiveImage src={heroImage} delay={100}>
              {(src, loading) => (
                <img
                  src={src}
                  alt="hero"
                  className="img-fluid"
                  style={{
                    width: "100%",
                    filter: loading ? "blur(1px)" : "none"
                  }}
                />
              )}
            </ProgressiveImage>
          )}

          {/* CONTENT */}
          <div className="block-content pt-10 text-center">

            <h1 className="welcome-heading mt-10">
              {heading}
            </h1>

            <h2 className="welcome-subheading mt-10 mb-10">
              {subHeading}
            </h2>

            <DelayLink
              to={brandRoute("/search-location")}
              delay={200}
              className="btn btn-lg btn-setup-location"
              style={{ backgroundColor: storeColor }}
            >
              {setupText}
              <Ink duration="500" hasTouch="true" />
            </DelayLink>

            {user && user.success ? (
              <p className="mt-3">
                {welcomeMessage} {user && user.data ? user.data.name : ""}
              </p>
            ) : (
              <p className="mt-3">
                {loginText}{" "}
                <NavLink
                  to={brandRoute("/login")}
                  style={{ color: storeColor }}
                >
                  {loginBtn}
                </NavLink>
              </p>
            )}

          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  brand: state.singlestore.brand,
  user: state.user.user,
  languages: state.languages.languages,
  language: state.languages.language
});

export default connect(
  mapStateToProps,
  {
    getSingleStoreConfig,
    getSingleLanguageData
  }
)(FirstScreen);
